import { CaseReducer, createSlice } from '@reduxjs/toolkit';

import { apiHostname } from 'shared/constants';
import { serializeLocationHeader } from 'shared/helpers';
import { AlphamartHttpError, ConvertersGroup, Coords } from 'shared/types';
import {
  GenericStoreReducer,
  GenericStoreSlice,
  GenericThunk,
  getGenericReducers,
} from './shared/createGenericStoreSlice';

interface PartialConvertersSlice extends GenericStoreSlice {
  partialConverters: ConvertersGroup[];
}

type PartialConvertersReducer = GenericStoreReducer<PartialConvertersSlice> & {
  clearPartialConverters: CaseReducer<PartialConvertersSlice, { type: string }>;
};

const fetchPartialConvertersSlice = createSlice<PartialConvertersSlice, PartialConvertersReducer>({
  name: 'partialConverters',
  initialState: {
    partialConverters: [],
    isPending: false,
    error: undefined,
  },
  reducers: {
    ...getGenericReducers(payload => ({
      partialConverters: payload,
    })),
    clearPartialConverters: state => ({
      ...state,
      partialConverters: [],
    }),
  },
});

export const {
  pending: fetchPartialConvertersAction,
  success: fetchPartialConvertersSuccessAction,
  failure: fetchPartialConvertersFailureAction,
  clearPartialConverters,
} = fetchPartialConvertersSlice.actions;

export const fetchPartialConverters =
  (position?: Coords): GenericThunk =>
  async (dispatch, getState, httpClient) => {
    try {
      const headers = position && { 'user-location': serializeLocationHeader(position) };
      dispatch(fetchPartialConvertersAction());
      const partialConverters = await httpClient.get(`${apiHostname}/api/converters/partial`, {
        headers,
      });
      dispatch(fetchPartialConvertersSuccessAction(partialConverters.data));
    } catch (error) {
      dispatch(
        fetchPartialConvertersFailureAction((error as AlphamartHttpError)?.response?.data.message),
      );
      return Promise.reject(error);
    }
  };

export default fetchPartialConvertersSlice.reducer;
